import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faqs-content-${index}`}
      aria-labelledby={`faqs-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ px: 1, pt: 2 }}>{children}</Box>}
    </div>
  );
}

// function a11yProps(index: number) {
//   return {
//     id: `faqs-${index}`,
//     'aria-controls': `faqs-${index}`,
//   };
// }

const FAQs = () => {
  const [value, setValue] = useState(7);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="Form W-9 FAQ: Answers to Common Taxpayer Questions"
          description="Get answers to common Form W-9 questions, including who needs to file, how to complete the form, TIN requirements, and when to submit it."
          keywords=""
          canonical="faqs/form-w9/"
        />
      }
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', md: 'column' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0, textAlign: 'center' }, py: 3 }}
        >
          <Box
            component="div"
            sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              <span className="highlight-container">
                <span className="highlight">FAQs - Form W-9</span>
              </span>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
              id="general"
            >
              Here are some common questions you may have about Form 941
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, px: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="flex-start"
            spacing={2}
          >
            <Hidden smDown>
              <Box
                sx={{
                  maxWidth: 180,
                  position: 'sticky',
                  top: 90,
                  border: '1px solid #ccc',
                  mt: '24px !important',
                  borderRadius: 2,
                  boxShadow: '0 0 10px rgba(0,0,0,.10)',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  orientation="vertical"
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    py: 1,
                  }}
                  className="faq-container"
                >
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          General
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      //  color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 2290
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{
                              width: 12,
                              height: 12,
                              marginRight: 4,
                              marginTop: 3,
                            }}
                          />
                          Form 2290 Amendments
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8849
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-EZ
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-ez/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-N
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 941
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-941/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 7004
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 4868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 15397
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-15397/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form W-9
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-w9/"
                  />
                </Tabs>
              </Box>
            </Hidden>
            <Hidden smUp>
              <Box
                sx={{
                  position: 'sticky',
                  top: 62,
                  backgroundColor: '#213e99',
                  zIndex: 1,
                  width: '100%',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    '& .MuiSvgIcon-root': { fill: '#fff' },
                    maxWidth: 380,
                    mt: '2px',
                  }}
                  className="faq-container"
                >
                  <Tab
                    label="General"
                    // {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label="Form 2290"
                    //  {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label="Form 2290 Amendments"
                    //  {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label="Form 8849"
                    //  {...a11yProps(3)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label="Form 990"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label="Form 990-N"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label="Form 7004"
                    //  {...a11yProps(5)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label="Form 4868"
                    //  {...a11yProps(6)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label="Form 8868"
                    //  {...a11yProps(7)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label="Form 15397"
                    //  {...a11yProps(8)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
                <Box sx={{ borderBottom: 0, borderColor: 'divider' }} />
              </Box>{' '}
            </Hidden>
            <Box
              sx={{
                width: '100%',
                pt: { sm: '8px !important' },
                px: { xs: 2, sm: 0 },
              }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <TabPanel>
                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: 18, sm: 20, md: 24, lg: 30 },
                    fontWeight: 600,
                  }}
                >
                  Form 7004
                </Typography> */}
                <Grid container spacing={0} rowSpacing={2} m={0} mt={0}>
                  <Grid size={12} sx={{ pt: '0 !important' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is a Form W-9?
                      </Typography>

                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          A{' '}
                          <Link
                            href="/request-form-w9-online-free/"
                            sx={{ color: '#0202ff' }}
                          >
                            Form W-9
                          </Link>{' '}
                          officially titled "Request for Taxpayer Identification
                          Number (TIN) and Certification," is used by businesses
                          and individuals to collect your tax identification
                          information. This information is needed to report
                          income paid to you of $600 or more during the tax year
                          on a{' '}
                          <Link
                            href="/information-returns/efile-irs-form-1099-nec/"
                            sx={{ color: '#0202ff' }}
                          >
                            Form 1099-NEC
                          </Link>
                          .
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        When do I need to fill out a Form W-9?
                      </Typography>

                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          You typically need to fill out a{' '}
                          <Link
                            href="/request-form-w9-online-free/"
                            sx={{ color: '#0202ff' }}
                          >
                            W-9
                          </Link>{' '}
                          whenever you're going to receive income from a source
                          that isn't a traditional employer. This includes
                          freelance work, receiving interest on investments, or
                          participating in certain types of online marketplaces.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What happens if I don't fill out a Form W-9?
                      </Typography>

                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          If you don't fill out a{' '}
                          <Link
                            href="/request-form-w9-online-free/"
                            sx={{ color: '#0202ff' }}
                          >
                            W-9
                          </Link>
                          , the payer may be required to withhold a higher
                          percentage of your income for taxes. It's best to
                          complete it to avoid delays in receiving your full
                          payment.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What are the common mistakes to avoid when completing a
                        Form W-9?
                      </Typography>

                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          Common mistakes to avoid when completing a{' '}
                          <Link
                            href="/request-form-w9-online-free/"
                            sx={{ color: '#0202ff' }}
                          >
                            Form W-9
                          </Link>{' '}
                          include:
                        </Typography>

                        <ul style={{ marginBottom: 12 }} itemProp="text">
                          <li style={{ marginBottom: 8 }}>
                            Providing an incorrect or incomplete TIN.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            Failing to sign and date the form.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            Selecting the wrong federal tax classification.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            Not providing updated information if your
                            circumstances change.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            Using a business name or disregarded entity name
                            instead of your personal name when required.
                          </li>
                        </ul>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Who needs to fill out a W-9 form?
                      </Typography>

                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          Anyone who is required to receive a payment must
                          provide a{' '}
                          <Link
                            href="/request-form-w9-online-free/"
                            sx={{ color: '#0202ff' }}
                          >
                            Form W-9
                          </Link>{' '}
                          if the payer requests it. This typically includes:
                        </Typography>

                        <ul style={{ marginBottom: 12 }} itemProp="text">
                          <li style={{ marginBottom: 8 }}>
                            Independent contractors and freelancers who receive
                            payments for their services.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            Individuals involved in real estate transactions.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            Recipients of mortgage interest payments.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            Those who receive certain types of income, such as
                            dividends, interest, or retirement distributions.
                          </li>
                        </ul>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information do I need to fill out on a W-9 form?
                      </Typography>

                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          You will need to provide your name, mailing address,
                          taxpayer identification number (TIN), which can be
                          your Social Security Number (SSN) if you are a sole
                          proprietor, and indicate whether you are a sole
                          proprietor, partnership, corporation, LLC, etc.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is the difference between a Form W-9 and a Form
                        W-4?
                      </Typography>

                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          A Form W-4 is used by employees to tell their employer
                          how much federal income tax to withhold from their
                          paycheck. A{' '}
                          <Link
                            href="/request-form-w9-online-free/"
                            sx={{ color: '#0202ff' }}
                          >
                            Form W-9
                          </Link>{' '}
                          is used to collect your tax ID for independent
                          contractor work where no withholding occurs.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How to Complete Form W-9 Online with TaxZerone?
                      </Typography>

                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <ul style={{ marginBottom: 12 }}>
                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>
                              Enter Vendor Details:
                            </span>{' '}
                            Input vendor info manually or import from
                            QuickBooks/Xero.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>
                              Send W-9 Request:
                            </span>{' '}
                            Email vendors to complete their W-9 form online.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>
                              Vendor Completion:
                            </span>{' '}
                            Vendors e-sign their W-9; you're notified instantly.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>
                              TIN Validation:
                            </span>{' '}
                            TaxZerone verifies TINs from W-9 forms.
                          </li>

                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>
                              File 1099 Forms:
                            </span>{' '}
                            Use W-9 data to e-file 1099 forms and distribute
                            copies.
                          </li>
                        </ul>
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 600, mb: 2 }}
                        >
                          Steps to Request W-9 from Vendors and Contractors
                          Using TaxZerone
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 600, mb: 1 }}
                        >
                          Step 1: Choose Request W-9
                        </Typography>
                        <ul style={{ marginBottom: 12 }}>
                          <li style={{ marginBottom: 8 }}>
                            Navigate to the main dashboard on TaxZerone.
                          </li>
                          <li>Select the "Request W-9" option.</li>
                        </ul>

                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 600, mb: 1 }}
                        >
                          Step 2: Enter Vendor Details
                        </Typography>
                        <ul style={{ marginBottom: 12 }}>
                          <li style={{ marginBottom: 8 }}>
                            Fill in the required details for the vendor or
                            contractor.
                          </li>
                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>Name:</span> Enter
                            the name of the vendor or contractor.
                          </li>
                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>Email:</span>{' '}
                            Enter the email address where the W-9 request will
                            be sent.
                          </li>
                        </ul>

                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 600, mb: 1 }}
                        >
                          Step 3: Submit the W-9 Request
                        </Typography>
                        <ul style={{ marginBottom: 12 }}>
                          <li style={{ marginBottom: 8 }}>
                            Review the entered details to ensure they are
                            correct.
                          </li>
                          <li style={{ marginBottom: 8 }}>
                            Click on the "Submit" button to send the W-9
                            request. A request link will be sent to the
                            specified email address of the vendor or contractor.
                          </li>
                        </ul>

                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 600, mb: 1 }}
                        >
                          Step 4: Notification of Submission
                        </Typography>
                        <ul style={{ marginBottom: 12 }}>
                          <li style={{ marginBottom: 8 }}>
                            You will receive an instant notification once the
                            vendor or contractor submits the completed W-9 form
                            through the provided link.
                          </li>
                        </ul>

                        <Typography variant="body1" itemProp="text">
                          These steps will ensure a smooth and efficient process
                          for collecting W-9 forms from your vendors and
                          contractors using TaxZerone.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to simplify your complex tax filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
          }}
        >
          Choose TaxZerone and file IRS tax forms online in easy steps.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=faqs`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default FAQs;
